import { render } from "./EconomySlide.vue?vue&type=template&id=0b79e4d4&scoped=true"
import script from "./EconomySlide.vue?vue&type=script&lang=js"
export * from "./EconomySlide.vue?vue&type=script&lang=js"

import "./EconomySlide.vue?vue&type=style&index=0&id=0b79e4d4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b79e4d4"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QHeader from 'quasar/src/components/header/QHeader.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QHeader,QTabs,QTab,QPageContainer,QPage,QImg});
